<template>
    <div class="cms-page">
        <div class="row mt-30 px-3" v-if="content">
            <div v-html="content"></div>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            content: '',
            store: $store
        }
    },
    created: function () {
        this.content = this.store.getters.getCmsContent ? JSON.parse(this.store.getters.getCmsContent) : (cmsContent ? JSON.parse(cmsContent) : '');
    },
    mounted: function () {
    }
}
</script>
